<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="p-[1.666px]"
    fill="none"
  >
    <path
      d="M14.1406 0H5.85938C2.62344 0 0 2.62344 0 5.85938V14.1406C0 17.3766 2.62344 20 5.85938 20H14.1406C17.3766 20 20 17.3766 20 14.1406V5.85938C20 2.62344 17.3766 0 14.1406 0ZM9.41055 15.4688C9.41055 16.0082 8.97344 16.4453 8.43398 16.4453H5.69961C4.62109 16.4453 3.74648 15.5707 3.74648 14.4922V5.50781C3.74648 4.4293 4.62109 3.55469 5.69961 3.55469H8.43398C8.97344 3.55469 9.41055 3.9918 9.41055 4.53125C9.41055 5.0707 8.97344 5.50781 8.43398 5.50781H6.18789C5.91836 5.50781 5.69961 5.72656 5.69961 5.99609V14.0039C5.69961 14.2734 5.91836 14.4922 6.18789 14.4922H8.43398C8.97344 14.4922 9.41055 14.9293 9.41055 15.4688ZM15.9676 10.6906L12.4438 14.2145C12.0625 14.5957 11.4441 14.5957 11.0625 14.2145C10.6813 13.8332 10.6813 13.2148 11.0625 12.8332L12.9191 10.9766H7.86016C7.3207 10.9766 6.88359 10.5395 6.88359 10C6.88359 9.46055 7.3207 9.02344 7.86016 9.02344H12.9191L11.0625 7.1668C10.6813 6.78555 10.6813 6.16719 11.0625 5.78555C11.4438 5.4043 12.0621 5.4043 12.4438 5.78555L15.9676 9.30938C16.3488 9.69063 16.3488 10.309 15.9676 10.6906Z"
      fill="currentColor"
    />
  </svg>
</template>